// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入增强版反调试模块
// import EnhancedAntiDebug from './utils/enhancedAntiDebug'

// 全局注册ElementUI
Vue.use(ElementUI)

// 初始化增强版反调试功能（在所有环境下启用）
// new EnhancedAntiDebug() // 临时注释以便调试

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js